import { ICreateProductDTO, IProductDTO, IProductLimitedDTO } from '../../legacy/shared-types';
import { API_UNPROTECTED } from 'api/apiUnprotected';
import { API } from '../../providers/ApiInterceptorProvider';
import { IUpdateProductParams, IProductsResponse, IProductsLimitedResponse } from './types';

export const productApi = {
  getProducts: async (): Promise<IProductsResponse> => {
    try {
      const response = await API.get<IProductDTO[]>('/product');

      return { status: response.status, data: response.data };
    } catch (err: any) {
      console.error(err);

      return { status: err.status, data: [] };
    }
  },
  getProductsLimited: async (): Promise<IProductsLimitedResponse> => {
    try {
      const response = await API_UNPROTECTED.get<IProductLimitedDTO[]>('/product/limited');

      return { status: response.status, data: response.data };
    } catch (err: any) {
      console.error(err);

      return { status: err.status, data: [] };
    }
  },
  getProductById: async (id: string): Promise<IProductDTO> => {
    try {
      const response = await API.get<IProductDTO>(`/product/${id}`);

      return response.data;
    } catch (err: any) {
      throw new Error("Couldn't get product");
    }
  },
  createProduct: async (newProduct: ICreateProductDTO) => {
    try {
      const response = await API.post<IProductDTO>('/product', newProduct);

      return { status: response.status, data: response.data };
    } catch (err: any) {
      const { message } = err.response.data;

      if (Array.isArray(message)) {
        throw new Error(message.join(';'));
      }

      throw new Error(message);
    }
  },
  updateProduct: async ({ data, id }: IUpdateProductParams) => {
    try {
      const response = await API.patch<IProductDTO>(`/product/${id}`, data);

      return { status: response.status, data: response.data };
    } catch (err: any) {
      const { message } = err.response.data;

      if (Array.isArray(message)) {
        throw new Error(message.join(';'));
      }

      throw new Error(message);
    }
  },
  verifyProduct: async (id: number | string) => {
    try {
      const response = await API.patch<void>(`/product/${id}/is-complete`);

      return { status: response.status, data: response.data };
    } catch (err: any) {
      const { message } = err.response.data;

      if (Array.isArray(message)) {
        throw new Error(message.join(';'));
      }

      throw new Error(message);
    }
  },
};
